const PriceFormation = () => import(/* webpackChunkName: "priceFormation" */ './PriceFormation.vue')

const index = {
  path: 'price/formation',
  name: 'Price Formation',
  component: PriceFormation,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

export default {
  index
}
